import { render, staticRenderFns } from "./HorizontalLayout.vue?vue&type=template&id=54ad0ffd"
import script from "./HorizontalLayout.vue?vue&type=script&lang=js"
export * from "./HorizontalLayout.vue?vue&type=script&lang=js"
import style0 from "./HorizontalLayout.vue?vue&type=style&index=0&id=54ad0ffd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports